import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {InputTextComponent} from '../input-text/input-text.component';
import {FormGroup} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    InputTextComponent
  ]
})
export class InputPasswordComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() hint?: string;
  @Input() form!: FormGroup;

  hide = true;
}
